export default __webpack_public_path__ + "static/media/919.457c5061.png";